module.exports = __webpack_public_path__ + "static/media/19ю102.bdea603b.webp";